export default "__VITE_ASSET__Bs3pTmM3__"